export default {
    props: {
        toolbarPosition: {
            type: String,
            default: undefined,
            kComposite: 'toolbar.position'
        }, 
        toolbarTools: {
            type: Array,
            default: undefined,
            kComposite: 'toolbar.tools'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-listbox-vue-wrapper/src/KendoListBox/Toolbar.js